// extracted by mini-css-extract-plugin
export default {"OutterDIV":"ContactIntro_OutterDIV__dhRdR","iconsDIV":"ContactIntro_iconsDIV__NzfNt","alignIconsAndText":"ContactIntro_alignIconsAndText__Y02RS"};